import { Alignment } from 'domain/constants/alignment';
import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const subtitle = css`
  margin-top: 0;
`;

const root = {
  default: css`
    display: block;
    text-align: left;
    width: 100%;
  `,
  centered: css`
    text-align: center;
  `,
};

const content = {
  default: css`
    margin-top: ${cssTheme.gu3};

    ${cssTheme.breakpoints.sm} {
      margin-right: ${cssTheme.gu3};
    }
  `,
  centered: css`
    margin-right: 0;
  `,
};

const container = {
  default: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: calc(${cssTheme.gu3} * -1);
  `,
  centered: css`
    align-items: center;
    flex-direction: column;
  `,
};

const ctas = css`
  margin-top: ${cssTheme.gu2};
  width: 100%;

  ${cssTheme.breakpoints.sm} {
    width: auto;
  }
`;

const cta = css`
  margin-top: ${cssTheme.gu1};
`;

export default ({ alignment }: { alignment: Alignment }) => {
  return {
    root: cx(root.default, alignment === Alignment.CENTER && root.centered),
    container: cx(container.default, alignment === Alignment.CENTER && container.centered),
    content: cx(content.default, alignment === Alignment.CENTER && content.centered),
    subtitle,
    ctas,
    cta,
  };
};
